import { useState, useEffect } from 'react';
import {NewsContent} from '../Molecules/NewsContent';
import {TablePagination} from 'src/Components/Molecules/Pagination';
import moment from "moment";
import useSWRImmutable from 'swr/immutable';
import Axios from 'axios';
import {Loader} from '../Molecules/Loader';

const fetcher = async query => {
    const response = await Axios.post(`${process.env.NEXT_PUBLIC_BASE_PATH}/api/graphql-call`, {query});

    return response.data;
};

export default function NewsSection({moreLink, pagination, quote}) {
    const [news, setNews] = useState([
        {
            title: "COMPANY NEWS",
            newsItems: []
        },
        {
            title: "REGULATORY NEWS",
            newsItems: []
        }
    ]);
    const [startAt, setStartAt] = useState(0);
    const [page, setPage] = useState(0);
    const [rowsPerPage, setRowsPerPage] = useState(10);
    const [startDate, setStartDate] = useState(moment(new Date(moment().subtract(6, 'months').calendar())).format('DD/MM/YYYY'));
    const [endDate, setEndDate] = useState(moment(new Date()).format('DD/MM/YYYY'));
    const [source, setSource] = useState("ALLIANCE");
    const [selectedIndex, setSelectedIndex] = useState(0);

    const { data, error } = useSWRImmutable(
        `query {
            newsHeadlines(
                symbol: ["${quote.marketCode}"], 
                startDate: "${startDate}", 
                endDate: "${endDate}", 
                limit: ${rowsPerPage}, 
                startAt: ${startAt},
                sourceCode: [${source}]
            ) {
                headlines {
                    title
                    symbols
                    typeCode
                    type
                    dateTime
                    id
                    sourceCode
                    source
                    provider
                    tags
                    timestamp
                }
                aggregate {
                    count
                }
            }
        }`, fetcher
    )

    useEffect(() => {
        if(data) {
            const {headlines} = data.newsHeadlines;
            const formattedHeadlines = [];
            headlines.map((headline) => {
                const date = moment(new Date(headline.dateTime));
                formattedHeadlines.push({
                    href: `${process.env.NEXT_PUBLIC_BASE_PATH}/sub/${quote.marketCode}/news-item/${headline.id}`,
                    title: headline.title,
                    date: date.format("ddd, DD/MM/YYYY - HH:mm:ss"),
                    tags: [{ // Temp until we know what to do with tags
                        title: headline.tags[0],
                        href: "#"
                    }]
                });
            });
    
            setNews([
                {
                    ...news[0],
                    newsItems: formattedHeadlines,
                },
                {
                    ...news[1],
                    newsItems: formattedHeadlines
                }
            ]);
        }
    }, [data]);

    const handleChangePage = (page) => {
        const startAt = page * rowsPerPage;

        if (page != -1 && startAt < data.newsHeadlines.aggregate.count) {
            setPage(page);
            setStartAt(startAt);
        }
	}

	const handleChangeRowsPerPage = (event) => {
        const { value } = event.target;
        const startAt = 0;

        setRowsPerPage(value);
        setPage(0);
        setStartAt(startAt);
	}

    const changeType = (index) => {
        setSelectedIndex(index);
        switch (index) {
            case 0:
                setSource("ALLIANCE");
                break;
            case 1:
                setSource("LSELSERNS, DGAPDGAPRNS");
                break;
        }
    }

    return <div className="ajb-grid-row margin-top-20">
        <div className="ajb-col-collapse">
            <div className="ajb-col-12 ajb-col-8-breakpoint">
                <div className="card z-depth-0 margin-0">
                    <div className="card-content padding-top-0-sm padding-right-0-sm padding-bottom-30-sm padding-left-0-sm" id="newsContent">
                        <h2 className="card-title" data-testid="newsHeader">
                            News
                        </h2>

                        {
                            news ? <NewsContent moreLink={moreLink ? `${process.env.NEXT_PUBLIC_BASE_PATH}/sub/${quote.marketCode}/news` : null} news={news} setSelectedIndex={changeType} selectedIndex={selectedIndex} /> : null
                        }

                        {
                            pagination && data && data.newsHeadlines ? (
                                <div className="ajb-grid-row text-align-right clearfix">
                                    <TablePagination
                                        count={data.newsHeadlines.aggregate.count}
                                        page={page}
                                        onChangePage={handleChangePage}
                                        rowsPerPage={rowsPerPage}
                                        onChangeRowsPerPage={handleChangeRowsPerPage}
                                    />
                                </div>
                            ) : null
                        }
                    </div>
                </div>
            </div>
        </div>
        {/*!data ? <Loader /> : null*/}
    </div>
}
